import { t } from "@/i18n-js/instance";
import { Loader } from "@/react/components/shared/uikit/Loader";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { usePunditUserContext } from "@/react/contexts/punditUserContext";
import { isCommunityAdmin } from "@/react/helpers/communityMemberHelpers";
import { useActiveView } from "@/react/hooks/utils/useActiveView";
import { useSelectMembersInfiniteQueryV2 } from "../../shared/MembersList/CommunityMembers/hooks/useSelectMembersInfiniteQueryV2";
import type { Views } from "../../shared/MembersList/constants";
import { VIEWS } from "../../shared/MembersList/constants";
import type { MemberDirectorySettings } from "../constants";
import { ControlsDropdown } from "../shared/ControlsDropdown";
import { MemberListWithFilters } from "../shared/MemberListWithFilters";

export const activeConnectionsFilter = {
  id: "connections-active",
  key: "connections",
  status: "active",
};

export const myConnectionsBaseFilter = [activeConnectionsFilter];

const i18nBase = "members_directory.connections";

export const MyConnections = ({
  memberDirectorySettings,
}: {
  memberDirectorySettings: MemberDirectorySettings;
}) => {
  const [activeView] = useActiveView({
    defaultCommunityView: memberDirectorySettings.view,
    views: VIEWS,
  });

  const { currentCommunityMember } = usePunditUserContext();

  const isAdmin = isCommunityAdmin(currentCommunityMember);

  const connectionsQuery = useSelectMembersInfiniteQueryV2({
    baseFilters: myConnectionsBaseFilter,
    defaultSort: "alphabetical",
    isAdminScope: false,
  });

  const hasNoConnections =
    connectionsQuery.totalMembers === 0 && !connectionsQuery.isLoading;

  if (connectionsQuery.isLoading) {
    return <Loader />;
  }

  if (hasNoConnections) {
    return (
      <div className="m-auto mx-2 mt-6 flex flex-col justify-center gap-y-2 text-center">
        <div className="flex flex-col justify-center gap-y-2 text-center">
          <Typography.TitleLg weight="bold" color="text-primary">
            {t(`members_directory.recommendations.build_connection_header`)}
          </Typography.TitleLg>
          <Typography.BodySm>
            {t(
              `members_directory.recommendations.build_connection_description`,
            )}
          </Typography.BodySm>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-y-4">
      <MemberListWithFilters
        activeView={activeView as Views}
        titleI18nKey={`${i18nBase}.title`}
        baseFilters={myConnectionsBaseFilter}
        shouldShowHiddenMemberTooltip={false}
        rightHeaderContent={isAdmin ? <ControlsDropdown /> : null}
      />
    </div>
  );
};
